import { simpleInit } from "./InitCompare";
import CompareToyota from "./components/toyota/CompareToyota";

export const init = simpleInit(CompareToyota);
